import { axios } from "@v2/shared/api";
const PARTICIPANT_ENDPOINT = "participants";
const ADDITIONAL_SERVICES_ENDPOINT = "additional-services";
const ADDITIONAL_ORDERS_ENDPOINT = "additional-orders";

export default {
  get(eventId, serviceId) {
    return axios.get(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${ADDITIONAL_SERVICES_ENDPOINT}/${serviceId}`
    );
  },

  additionalServices(eventId, data) {
    return axios.get(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${ADDITIONAL_SERVICES_ENDPOINT}`,
      {
        params: data
      }
    );
  },

  orderCreate(eventId, data) {
    return axios.post(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${ADDITIONAL_ORDERS_ENDPOINT}`,
      data
    );
  },
  downloadChatDocument(eventId, orderId, fileId) {
    return axios.get(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${ADDITIONAL_ORDERS_ENDPOINT}/${orderId}/download/files/${fileId}`,
      {
        responseType: "arraybuffer"
      }
    );
  },
  confirmAdditionalOrder(participantId, orderId) {
    return axios.post(
      `${PARTICIPANT_ENDPOINT}/${participantId}/${ADDITIONAL_ORDERS_ENDPOINT}/${orderId}/accept`
    );
  },

  cancelAdditionalOrder(participantId, orderId) {
    return axios.post(
      `${PARTICIPANT_ENDPOINT}/${participantId}/${ADDITIONAL_ORDERS_ENDPOINT}/${orderId}/cancel`
    );
  },

  downloadAdditionalOrder(participantId, orderId) {
    return axios.get(
      `${PARTICIPANT_ENDPOINT}/${participantId}/${ADDITIONAL_ORDERS_ENDPOINT}/${orderId}/download`,
      {
        responseType: "arraybuffer"
      }
    );
  },
  downloadAdditionalOrderInvoice(participantId, orderId) {
    return axios.get(
      `${PARTICIPANT_ENDPOINT}/${participantId}/${ADDITIONAL_ORDERS_ENDPOINT}/${orderId}/download/documents`,
      {
        responseType: "arraybuffer"
      }
    );
  }
};
